import axios from 'axios';

import { isDev } from '../helpers/os';

export async function getLocationData({ userId, lat, lng }) {
  try {
    /* if (isDev) {
      return {
        place_id: 304002625,
        licence: 'Data © OpenStreetMap contributors, ODbL 1.0. http://osm.org/copyright',
        osm_type: 'way',
        osm_id: 14041119,
        lat,
        lon: lng,
        category: 'highway',
        type: 'tertiary',
        place_rank: 26,
        importance: 0.0533433333333333,
        addresstype: 'road',
        name: '325 Avenue',
        display_name: '325 Avenue, Chase County, Nebraska, United States',
        address: {
          road: '325 Avenue',
          county: 'Chase County',
          state: 'Nebraska',
          'ISO3166-2-lvl4': 'US-NE',
          country: 'United States',
          country_code: 'us',
        },
        boundingbox: ['40.5665160', '40.5809770', '-101.7804270', '-101.7797200'],
      };
    } */
    const response = await axios.get('https://nominatim.openstreetmap.org/reverse', {
      headers: {
        'User-Agent': `skeddy/1.0 (${userId}@skeddy.com)`,
        'Accept-Language': 'en',
      },
      params: {
        format: 'jsonv2',
        lat,
        lon: lng,
        addressdetails: 1,
        'accept-language': 'en',
      },
    });

    return response.data;
  } catch (error) {
    return null;
  }
}
